import React, { useState } from "react";

import { Box, Flex, Spinner } from "@chakra-ui/react";
import { useParams } from "react-router-dom";

import { PaginationComponent } from "common/components/Pagination";
import { ActivoCompletoOutput } from "components/Portfolio/types/activos";
import { THUNK_STATE } from "config/types";
import { getComunicacionesPendientesThunk, getInfoActivosThunk } from "store/portfolio/thunks";
import { useAppDispatch, useAppSelector } from "store/store";

import { ComunicacionesHeader } from "./Header";
import { ComunicacionesRow } from "./Row";
import { ModalComunicaciones } from "./Row/Comunicaciones";

export const Comunicaciones: React.FC = () => {
	const assetsInfo = useAppSelector((state) => state.portfolio.assetsInfo);
	const page = useAppSelector((state) => state.portfolio.page);
	const filterSelection = useAppSelector((state) => state.portfolio.filterSelection);
	const orderBy = useAppSelector((state) => state.portfolio.orderBy);
	const { portfolioParams } = useParams();
	const dispatch = useAppDispatch();

	const ref = React.useRef<HTMLDivElement>(null);
	const [activoComunicaciones, setActivoComunicaciones] = useState<ActivoCompletoOutput>();

	const refetchComunicaciones = React.useCallback(() => {
		dispatch(
			getInfoActivosThunk({
				...(filterSelection !== null && { filterSelection }),
				...(orderBy !== null && { order: `${orderBy.column}.${orderBy.direction}` }),
				page,
				view: portfolioParams,
			}),
		);
		dispatch(getComunicacionesPendientesThunk());
	}, [dispatch, filterSelection, orderBy, page, portfolioParams]);

	const autoScrollToTop = React.useCallback(() => {
		ref.current?.scrollIntoView({ behavior: "smooth" });
	}, [page]);

	React.useEffect(() => {
		if (page > 1) {
			autoScrollToTop();
		}
	}, [page]);

	return (
		<>
			<Box ref={ref}>
				<ComunicacionesHeader />
				<Box overflow="hidden" overflowY="scroll" height="75vh">
					{assetsInfo.thunkState === THUNK_STATE.FULFILLED ? (
						assetsInfo.data.data.map((asset, i) => (
							<React.Fragment key={i}>
								<ComunicacionesRow asset={asset} onOpenComunicaciones={setActivoComunicaciones} />
							</React.Fragment>
						))
					) : (
						<Flex w="100%" my="2rem" justifyContent="center">
							<Spinner />
						</Flex>
					)}
					<PaginationComponent thunkState={assetsInfo.thunkState} pagination={assetsInfo.data.pagination} />
				</Box>
			</Box>
			<ModalComunicaciones
				asset={activoComunicaciones}
				onClose={() => setActivoComunicaciones(undefined)}
				type="comunicaciones"
				onComunicacionesActualizadas={refetchComunicaciones}
			/>
		</>
	);
};
